/**
 * <marou-locale-switch> — inline language/country switcher with autocomplete-safe submit.
 *
 * Supports two markup modes:
 *   1. Combo select (default in snippets/marou-locale-switch.liquid):
 *      one <select data-combo-select> whose option values are
 *      `language_iso|country_iso`. Hidden inputs name="locale_code" and
 *      name="country_code" inside the form get populated from the split
 *      value on change.
 *   2. Two separate <select name="locale_code"> + <select name="country_code">.
 *      Each fires submit-on-change directly.
 *
 * Safeguards:
 *   - data-default-value snapshot prevents phantom change events (bfcache,
 *     autocomplete) from looping the page.
 *   - Wrapper class .marou-inline-locale-form (NOT .thb-localization-forms)
 *     so bcorp's legacy class Localization (assets/app.js:766) does not
 *     bind a duplicate submit listener.
 */
if (!customElements.get('marou-locale-switch')) {
  class MarouLocaleSwitch extends HTMLElement {
    connectedCallback() {
      this.form = this.querySelector('form');
      if (!this.form) return;
      this.comboSelect = this.querySelector('select[data-combo-select]');
      if (this.comboSelect) {
        this.localeInput = this.form.querySelector('input[name="locale_code"]');
        this.countryInput = this.form.querySelector('input[name="country_code"]');
        this.comboSelect.addEventListener('change', this.onComboChange.bind(this));
        return;
      }
      this.selects = Array.from(
        this.querySelectorAll('select[name="locale_code"], select[name="country_code"]')
      );
      if (this.selects.length === 0) return;
      this.selects.forEach((sel) => {
        sel.addEventListener('change', this.onSingleChange.bind(this));
      });
    }
    onComboChange(event) {
      const sel = event.currentTarget;
      const original = sel.dataset.defaultValue || '';
      if (sel.value === original) return;
      const opt = sel.selectedOptions && sel.selectedOptions[0];
      if (opt && opt.dataset.external === 'true' && opt.dataset.href) {
        window.open(opt.dataset.href, '_blank', 'noopener,noreferrer');
        sel.value = original;
        return;
      }
      const parts = sel.value.split('|');
      if (parts.length !== 2 || !parts[0] || !parts[1]) return;
      if (this.localeInput) this.localeInput.value = parts[0];
      if (this.countryInput) this.countryInput.value = parts[1];
      this.form.submit();
    }
    onSingleChange(event) {
      const sel = event.currentTarget;
      const original = sel.dataset.defaultValue || '';
      if (sel.value === original) return;
      const opt = sel.selectedOptions && sel.selectedOptions[0];
      if (opt && opt.dataset.external === 'true' && opt.dataset.href) {
        window.open(opt.dataset.href, '_blank', 'noopener,noreferrer');
        sel.value = original;
        return;
      }
      this.form.submit();
    }
  }
  customElements.define('marou-locale-switch', MarouLocaleSwitch);
}
